import React from 'react'

export default function Layout() {
  return (
    <>
      <h1>Layout</h1>
      <p><span className='tag-grey bold'>.row</span> and <span className='tag-grey bold'>.col</span> classes help to control the layout of the page</p>
      <p>Creates a new <span className='tag-grey bold'>.row</span> while the <span className='tag-grey bold'>.col</span> manages how the spaces (columns) within that row is managed</p>
    
      <h2>Code:</h2>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="row"&gt;<br />
            &lt;p class="col c-light bc-blue p-1"&gt;hero text&lt;/p&gt;<br />
            &lt;p class="col c-light bc-green p-1"&gt;hero sub text&lt;/p&gt;<br />
         &lt;/div&gt;
          </p>
      </div>

      <h2>Result:</h2>
      <div className='border-grey p-1 border-curve'>
      <div className="row">
            <p className="col c-light bc-blue p-1">hero text</p>
            <p className="col c-light bc-green p-1">hero sub text</p>
        </div>  
      </div>

      <h2>Col-(number: 1-10)</h2>
      <p> a <span className='tag-grey bold'>.row</span> element contains 10 columns. You can specify the sizing of a column by adding any number from 1-10 e.g <span className='tag-grey bold'>.col-1</span></p>
      <p>Do take into account that adding margins or paddings directly to the column elements can affect the sizing</p>
      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="row"&gt;<br />
            &lt;p class="col-2 c-light bc-blue py-1"&gt;hero text&lt;/p&gt;<br />
            &lt;p class="col-8 c-light bc-green py-1"&gt;hero sub text&lt;/p&gt;<br />
         &lt;/div&gt;
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
      <div className="row">
            <p className="col-2 c-light bc-blue py-1">hero text</p>
            <p className="col-8 c-light bc-green py-1">hero sub text</p>
        </div>  
      </div>

      <h2>Col-(screenSize)-(number: 1-10)</h2>
      <p> You can specify the sizing of a column per screen break points by adding the shortname of the breakpoints. The available break point are: <span className='tag-grey bold my-1'>xs</span> <span className='tag-grey bold'>sm</span> <span className='tag-grey bold'>md</span> <span className='tag-grey bold'>lg</span> <span className='tag-grey bold'>xl</span></p>
      <ul className='my-items-1'>
        <li>xs - maximum width: 575px</li>
        <li>sm - minimum width: 576px</li>
        <li>md - minimum width: 768px</li>
        <li>lg - minimum width: 992px</li>
        <li>xl - minimum width: 1200px</li>
      </ul>
      <h3>Code:</h3>
      <div className='border-grey pl-1 border-curve bc-grey'>
          <p className='medium'>
          &lt;div class="row"&gt;<br />
            &lt;p class="col-lg-4 c-light bc-blue py-1"&gt;hero text&lt;/p&gt;<br />
            &lt;p class="col-lg-6 c-light bc-green py-1"&gt;hero sub text&lt;/p&gt;<br />
         &lt;/div&gt;
          </p>
      </div>

      <h3>Result:</h3>
      <div className='border-grey p-1 border-curve'>
      <div className="row">
            <p className="col-lg-4 c-light bc-blue py-1">hero text</p>
            <p className="col-lg-6 c-light bc-green py-1">hero sub text</p>
        </div>  
      </div>


    </>

    
  )
}
